<template>
  <div class="row">
    <div class="col-8">
      <svg :class="statusClass" />
      {{ attributeDetail.description }}
    </div>
    <div class="col-4 text-right">
      <a
        v-if="attributeDetail.covered"
        :href="callbackUrl"
        :target="linkTarget"
        class="btn btn-link btn-sm"
      >
        Order
      </a>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    statusClass() {
      const classes = ['icon'];

      // hashtable lookup to cater for future states
      classes.push(
        {
          true: 'coverage',
          false: 'nocoverage',
        }[this.attributeDetail.covered],
      );
      return classes;
    },
  },
  name: 'CoverageInfoGridRow',
  props: {
    attributeDetail: {
      type: Object,
      required: true,
      validator(rcvdAttributeDetail) {
        return (
          rcvdAttributeDetail.covered !== null
          && rcvdAttributeDetail.description !== null
          && typeof rcvdAttributeDetail.covered === 'boolean'
          && typeof rcvdAttributeDetail.description === 'string'
        );
      },
    },
    callbackUrl: {
      type: String,
      required: true,
    },
    coordinate: {
      type: Object,
      required: true,
      validator(rcvdCoordinate) {
        return (
          rcvdCoordinate.latitude !== null
          && rcvdCoordinate.longitude !== null
          && typeof rcvdCoordinate.latitude === 'number'
          && typeof rcvdCoordinate.longitude === 'number'
          && rcvdCoordinate.latitude >= -90
          && rcvdCoordinate.latitude <= 90
          && rcvdCoordinate.longitude >= -180
          && rcvdCoordinate.longitude <= 180
        );
      },
    },
    linkTarget: {
      default: '_blank',
      required: false,
      type: String,
    },
  },
};
</script>
<style scoped>
.icon {
  background-repeat: no-repeat, repeat-y;
  background-size: 25px 25px;
  height: 25px;
  width: 25px;
}
.coverage {
  background-image: url('../../assets/icons/success.svg');
}
.nocoverage {
  background-image: url('../../assets/icons/warning.svg');
}
a.btn-link{
  color: #E60000;
}
.btn-link:hover {
    color: #9a0000;
    text-decoration: underline;
}
</style>
